import { createContext, useContext, useLayoutEffect } from 'react';

/**
 * Lets a page own the top-bar title. When a page calls useAdminPageTitle, the
 * AdminLayout top bar renders that title as the page's <h1>; pages that don't
 * call it keep their own in-page h1 and the top bar shows the nav label as
 * plain (non-heading) text, so headings are never duplicated.
 */
export const AdminPageTitleContext = createContext<(title: string | null) => void>(() => {});

export function useAdminPageTitle(title: string) {
  const setTitle = useContext(AdminPageTitleContext);
  useLayoutEffect(() => {
    setTitle(title);
    return () => setTitle(null);
  }, [setTitle, title]);
}
